import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Cyprus: Country = {
    identifier: "Cyprus",
    name: "Cyprus",
    countryCode: "CY",
    group: CountryGroup.EUROPE,
    isUNMember: true,
    flag: "🇨🇾",
    svgPath: "m 571.61575,356.5314 -1.463,1.034 -0.095,0.307 0.065,0.212 0.206,0.257 0.054,0.067 0.074,0.195 -0.319,0.058 -0.32,0.019 -0.178,-0.026 -0.168,0.012 -0.519,0.557 -0.279,0.189 -0.332,0.112 -0.338,0.067 -0.17,0.009 -0.15,0.07 -0.105,0.129 -0.002,0.125 -0.045,0.103 -0.186,-0.021 -0.077,-0.202 -0.132,-0.087 -0.329,0.045 -0.16,-0.006 -0.526,-0.192 -0.159,-0.08 -0.099,-0.165 -0.271,-0.596 -0.045,-0.443 0.252,0.114 0.236,-0.138 0.227,-0.225 0.271,-0.092 0.169,0.04 0.168,0.04 0.302,-0.072 0.13,-0.334 0.043,-0.384 0.51,0.11 0.518,0.057 0.423,0.019 0.418,-0.062 1.279,-0.411 0.362,-0.246 0.225,-0.084 0.389,-0.203 0.407,-0.113 z",
}
